(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_aerie_duo_hero"] && !Shopify.designMode) return;
  try {
    
const initDuoVideos = (root) => {
  for (const video of root.querySelectorAll('.aerie-duo-card__video')) {
    const poster = video.nextElementSibling;
    if (!poster?.classList.contains('aerie-duo-card__video-poster')) continue;
    const hide = () => poster.classList.add('aerie-duo-card__video-poster--hidden');
    if (video.readyState >= 3) {
      hide();
    } else {
      video.addEventListener('canplay', hide, { once: true });
    }
  }
};

initDuoVideos(document);
document.addEventListener('shopify:section:load', (e) => initDuoVideos(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_external_lead_form"] && !Shopify.designMode) return;
  try {
    
  class ExternalLeadForm extends HTMLElement {
    constructor() {
      super();
      this.form = null;
      this.fieldsContainer = null;
      this.successContainer = null;
      this.errorContainer = null;
      this.errorMessage = null;
      this.retryBtn = null;
      // Bound handlers stored as instance properties for proper cleanup
      this._boundSubmit = null;
      this._boundRetry = null;
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      this.fieldsContainer = this.querySelector('[ref="fields"]');
      this.successContainer = this.querySelector('[ref="success"]');
      this.errorContainer = this.querySelector('[ref="error"]');
      this.errorMessage = this.querySelector('[ref="errorMessage"]');
      this.retryBtn = this.querySelector('[ref="retryBtn"]');

      // Store bound handlers for proper add/remove lifecycle
      this._boundSubmit = this.handleSubmit.bind(this);
      this._boundRetry = this.handleRetry.bind(this);

      // Prefill from URL query parameters
      this.prefillFromURL();

      // Intercept submit for validation and enhanced feedback
      this.form.addEventListener('submit', this._boundSubmit);

      // Retry button
      if (this.retryBtn) {
        this.retryBtn.addEventListener('click', this._boundRetry);
      }
    }

    disconnectedCallback() {
      if (this.form && this._boundSubmit) {
        this.form.removeEventListener('submit', this._boundSubmit);
      }
      if (this.retryBtn && this._boundRetry) {
        this.retryBtn.removeEventListener('click', this._boundRetry);
      }
    }

    prefillFromURL() {
      const params = new URLSearchParams(window.location.search);
      const prefillFields = ['inp_1', 'inp_2', 'inp_3'];

      for (const name of prefillFields) {
        if (params.has(name)) {
          const input = this.form.querySelector(`[name="${name}"]`);
          if (input) {
            input.value = decodeURIComponent(params.get(name));
          }
        }
      }
    }

    handleSubmit(event) {
      event.preventDefault();

      // Clear previous invalid states
      const invalidInputs = this.form.querySelectorAll('[aria-invalid="true"]');
      for (const input of invalidInputs) {
        input.removeAttribute('aria-invalid');
      }

      // Run validation
      const errors = this.validateForm();
      if (errors.length > 0) {
        this.showError(errors[0]);
        const firstInvalid = this.form.querySelector(':invalid');
        if (firstInvalid) {
          firstInvalid.setAttribute('aria-invalid', 'true');
          firstInvalid.focus();
        }
        return;
      }

      // Serialize form data and submit to external endpoint
      this.submitToExternalEndpoint();
    }

    validateForm() {
      const errors = [];

      // inp_1: Nombre (min 2 chars)
      const nameInput = this.form.querySelector('[name="inp_1"]');
      if (nameInput && nameInput.value.trim().length < 2) {
        errors.push('Ingresa tu nombre completo (mínimo 2 caracteres).');
      }

      // inp_2: Apellidos (min 2 chars)
      const lastnameInput = this.form.querySelector('[name="inp_2"]');
      if (lastnameInput && lastnameInput.value.trim().length < 2) {
        errors.push('Ingresa tus apellidos (mínimo 2 caracteres).');
      }

      // inp_3: Email (valid format)
      const emailInput = this.form.querySelector('[name="inp_3"]');
      if (emailInput && !this.isValidEmail(emailInput.value)) {
        errors.push('Ingresa un correo electrónico válido (debe incluir @).');
      }

      // inp_4899: Documento (13 digits)
      const docInput = this.form.querySelector('[name="inp_4899"]');
      if (docInput && !/^[0-9]{13}$/.test(docInput.value)) {
        errors.push('Ingresa tu DPI/Cédula: 13 dígitos sin espacios ni guiones.');
      }

      // inp_37: Celular (8 digits)
      const phoneInput = this.form.querySelector('[name="inp_37"]');
      if (phoneInput && !/^[0-9]{8}$/.test(phoneInput.value)) {
        errors.push('Ingresa tu número de celular: 8 dígitos sin espacios ni guiones.');
      }

      // optin checkbox
      const optinCheckbox = this.form.querySelector('[name="optin"]');
      if (optinCheckbox && !optinCheckbox.checked) {
        errors.push('Debes aceptar los términos y condiciones para continuar.');
      }

      return errors;
    }

    isValidEmail(email) {
      return email.includes('@') && email.includes('.') && email.length >= 5;
    }

    async submitToExternalEndpoint() {
      const formData = new FormData(this.form);
      const params = new URLSearchParams(formData);
      const endpoint = this.form.action;
      const submitUrl = `${endpoint}?${params.toString()}`;

      // Disable submit button during request
      const submitBtn = this.form.querySelector('button[type="submit"]');
      const originalBtnText = submitBtn ? submitBtn.textContent : 'Registrarme';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Enviando...';
      }

      try {
        // BEST-EFFORT FETCH: mode: 'no-cors' produces opaque response.
        // Cannot verify server 4xx/5xx status — success detection is network-failure-only.
        // If fetch completes (no network error), assume success optimistically.
        // If fetch throws (network failure), fallback to native GET navigation.
        await fetch(submitUrl, { method: 'GET', mode: 'no-cors' });
        
        // Fetch completed without network error — show success optimistically
        // (Caveat: server 4xx/5xx would still show success due to opaque response)
        this.showSuccess();
        
      } catch (error) {
        // Network failure detected — restore button state
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalBtnText;
        }
        
        // FALLBACK TO NATIVE GET NAVIGATION (spec-compliant primary path)
        // Remove submit listener to allow native form submission
        this.form.removeEventListener('submit', this._boundSubmit);
        // Programmatically submit form — browser navigates to endpoint URL
        this.form.submit();
      }
    }

    showError(message) {
      if (this.errorMessage) {
        this.errorMessage.textContent = message;
      }
      if (this.errorContainer) {
        this.errorContainer.removeAttribute('aria-hidden');
      }
      // Focus on error for accessibility
      if (this.errorContainer) {
        this.errorContainer.focus();
      }
    }

    handleRetry() {
      // Hide error, show fields again
      if (this.errorContainer) {
        this.errorContainer.setAttribute('aria-hidden', 'true');
      }
      if (this.errorMessage) {
        this.errorMessage.textContent = '';
      }
      // Focus on first input
      const firstInput = this.form.querySelector('input:not([type="hidden"])');
      if (firstInput) {
        firstInput.focus();
      }
    }

    showSuccess() {
      if (this.fieldsContainer) {
        this.fieldsContainer.style.display = 'none';
      }
      if (this.successContainer) {
        this.successContainer.removeAttribute('aria-hidden');
        // Focus for accessibility announcement
        this.successContainer.focus();
      }
    }
  }

  customElements.define('external-lead-form', ExternalLeadForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_mobile_categories"] && !Shopify.designMode) return;
  try {
    
  for (const details of document.querySelectorAll('.mob-cats__details')) {
    const summary = details.querySelector('.mob-cats__summary');
    const list = details.querySelector('.mob-cats__list');
    if (!summary || !list) continue;

    summary.addEventListener('click', (e) => {
      if (!details.open) return;
      e.preventDefault();
      list.classList.add('mob-cats__list--closing');
      list.addEventListener(
        'transitionend',
        () => {
          list.classList.remove('mob-cats__list--closing');
          details.removeAttribute('open');
        },
        { once: true }
      );
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_stacked_hero"] && !Shopify.designMode) return;
  try {
    
const initStackedVideos = (root) => {
  for (const video of root.querySelectorAll('.stacked-panel__video')) {
    const poster = video.nextElementSibling;
    if (!poster?.classList.contains('stacked-panel__video-poster')) continue;
    const hide = () => poster.classList.add('stacked-panel__video-poster--hidden');
    if (video.readyState >= 3) {
      hide();
    } else {
      video.addEventListener('canplay', hide, { once: true });
    }
  }
};

initStackedVideos(document);
document.addEventListener('shopify:section:load', (e) => initStackedVideos(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_tyc_content"] && !Shopify.designMode) return;
  try {
    
  /**
   * TycContentComponent — llave-cerradura
   *
   * Cada nav_link[data-group="N"] activa el panel .tyc-content__group[data-group="N"].
   * Si el link tiene target="_blank" (externa), la abre EN NUEVA PESTAÑA y además
   * activa el panel. Si el link no tiene data-group, navega normalmente.
   */
  class TycContentComponent extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.#handleClick);
      window.addEventListener('hashchange', this.#handleHash);
      this.#handleHash();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#handleClick);
      window.removeEventListener('hashchange', this.#handleHash);
    }

    #handleHash = () => {
      const hash = window.location.hash.slice(1);
      const matched = hash
        ? this.querySelector(`.tyc-content__group[data-group="${CSS.escape(hash)}"]`)
        : null;

      if (matched) {
        this.#activateGroup(hash);
      } else {
        const first = this.querySelector('.tyc-content__group[data-group]');
        if (first) this.#activateGroup(first.dataset.group);
      }
    };

    #handleClick = (event) => {
      const link = event.target.closest('.tyc-content__nav-link[data-group]');
      if (!link) return;

      const isExternal = link.target === '_blank';

      // Si no es externa, cancelar la navegación (el panel reemplaza la acción)
      if (!isExternal) event.preventDefault();

      this.#activateGroup(link.dataset.group);
    };

    #activateGroup(groupId) {
      const id = String(groupId);

      // Nav links: marcar activo
      for (const link of this.querySelectorAll('.tyc-content__nav-link[data-group]')) {
        const isActive = link.dataset.group === id;
        link.setAttribute('aria-current', isActive ? 'true' : 'false');
      }

      // Panels: mostrar/ocultar con el atributo hidden nativo
      for (const group of this.querySelectorAll('.tyc-content__group[data-group]')) {
        if (group.dataset.group === id) {
          group.removeAttribute('hidden');
        } else {
          group.setAttribute('hidden', '');
        }
      }
    }
  }

  if (!customElements.get('tyc-content-component')) {
    customElements.define('tyc-content-component', TycContentComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
